import { ReactNode } from 'react';
import { Grid, SxProps, Typography, useMediaQuery } from '@mui/material';
import { styles } from './styles';
import { theme } from '~/theme';
import type { SystemStyleObject, Theme } from '@mui/system';

interface ITableCellProps {
  children: ReactNode;
  title: string;
  size: number;
  sx?: SxProps<Theme>;
  stylesProps?: SystemStyleObject<Theme>;
}

const TableCell = ({ children, title, size, sx, stylesProps }: ITableCellProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Grid
      container
      size={{ md: size, sm: 12, xs: 12 }}
      sx={[(theme) => ({ ...styles.item(theme) }), sx as SystemStyleObject<Theme>]}
    >
      {isMobile && (
        <Grid size={{ md: 0, sm: 6, xs: 6 }} sx={styles.mobileTableCell}>
          <Typography variant="body2">{title}</Typography>
        </Grid>
      )}
      <Grid sx={{ ...stylesProps, ...styles.tableCell }}>{children}</Grid>
    </Grid>
  );
};

export default TableCell;
